export default {
      id: "send_insurance-usage",
      viewBox: "0 0 19 23",
      url: __webpack_public_path__ + "img/icons.svg#send_insurance",
      toString: function () {
        return this.url;
      }
    }